import { render, staticRenderFns } from "./BatchProcessViewBatch.vue?vue&type=template&id=f2d08ab6&scoped=true&"
import script from "./BatchProcessViewBatch.vue?vue&type=script&lang=js&"
export * from "./BatchProcessViewBatch.vue?vue&type=script&lang=js&"
import style0 from "./BatchProcessViewBatch.vue?vue&type=style&index=0&id=f2d08ab6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d08ab6",
  null
  
)

export default component.exports